import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NAV_ITEMS = [
  { key: "dashboard", label: "Dashboard", to: "/admin1" },
  { key: "users", label: "Users", to: "/admin1/users" },
  { key: "verification", label: "Verification", to: "/admin1/verification-queue" },
  { key: "withdraw_eligibility", label: "Withdraw Eligibility", to: "/admin1/withdraw-eligibility" },
  { key: "withdraw_requests", label: "Withdraw Requests", to: "/admin1/withdraw-requests" },
  { key: "paid_withdrawals", label: "Paid Withdrawals", to: "/admin1/paid-withdrawals" },
  { key: "accounting", label: "Accounting", to: "/admin1/accounting-reports" },
  { key: "support", label: "Support", to: "/admin1/support" },
  { key: "reports", label: "Reports", to: "/admin1/reports" },
  { key: "finance", label: "Finance", to: "/admin1/finance" },
  { key: "audit_logs", label: "Audit Logs", to: "/admin1/audit-logs" },
];

export default function Admin1Layout({ children }) {
  const { t } = useTranslation();

  return (
    <div className="admin1-shell">
      <aside className="admin1-sidebar">
        <div className="admin1-brand">
          <div className="admin1-brand__title">
            {t("admin.support.nav.brand_title", { defaultValue: "Livora Admin1" })}
          </div>
          <div className="admin1-brand__subtitle">
            {t("admin.support.nav.brand_subtitle", { defaultValue: "Control Center" })}
          </div>
        </div>

        <nav className="admin1-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.key}
              to={item.to}
              className={({ isActive }) =>
                `admin1-nav__item ${isActive ? "is-active" : ""}`
              }
            >
              {t(`admin.support.nav.${item.key}`, { defaultValue: item.label })}
            </NavLink>
          ))}
        </nav>
      </aside>

      <main className="admin1-main">{children}</main>
    </div>
  );
}
